const qtyInputEventHandler = (input) => {
  if (input == null){
    return
  }
  const qtyMax = parseInt(input.dataset.max);
  const qtyMin = parseInt(input.dataset.min);
  
  let qtyValue = input.value;
  let timeoutId;
  input.addEventListener("input", (e) => {
    e.preventDefault();
    if(parseInt(input.value) > qtyMax){
       input.value = qtyValue;
    }
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    timeoutId = setTimeout(function () {
      /*
        The reason for the setTimeout: Lets say the product limit is between 4 and 15. The customer wants to buy 12 units of the product.
        In order to write number 12, the customer firstly needs to wrie 1, but the 1 < 4, and thus code will not allow the user to write it. Thats why
        there is setTimeout, user have 1.5 seconds to find the number 12, if he doesen't the input value will be set to qtyMin. In case during these 1.3 user manages to click
        on "Add to cart" button, the program will check if the input.value is less than the 4, and if it is, it will give user an error. 
      */
      if (parseInt(input.value) < qtyMin && input.value.length > 0) {
       input.value = qtyMin;
      }
    }, 1500)
    qtyValue = input.value
  })
} 

const productPageQtyLogic = () => {
    const productDescription = document.getElementById("product-description");
    if (productDescription == null) {
      return;
    }
    const qtyInput = productDescription.querySelector(".product__quantity-input");
    if (qtyInput == null) {
      return;
    }

    qtyInputEventHandler(qtyInput)
  
    
}

productPageQtyLogic()



const checkForMinMax = (input) =>{
  const inputValue = parseInt(input.value)
  const inputMax = parseInt(input.dataset.max)
  const inputMin = parseInt(input.dataset.min)
  
  if (inputValue >= inputMax) {
    input.value = inputMax
  }

  if (inputValue < inputMin) {
    input.value = inputMin
  }
  
  
}


const checkForOverFlow = async (form) => {
  const productId = form.dataset.productId;
  const newQty = parseInt(form.querySelector(".product__quantity-input").value)
  const productLimit  = parseInt(form.querySelector(".product__quantity-input").dataset.max)
  const productMin = parseInt(form.querySelector(".product__quantity-input").dataset.min)
  if  (productLimit == NaN || productLimit == undefined || productMin == NaN || productMin == undefined) {
    return false;
  }
  if (newQty < productMin){
    alert("Product Is Below Limit")
    return true;
  }
  let cartContents = await  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { return data.items });
  console.log(cartContents)
  const product = cartContents.filter(product => product.product_id == productId)
  if (product.length > 0) {
    currentQty = product[0].quantity
    if ((newQty + currentQty) > productLimit) {
      alert("Product Is Above Limit")
      return true;
    }
  }
  return false;
}

function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

const isInputNumber = (form) => {
  const newQty = form.querySelector(".product__quantity-input").value
  const result = (newQty.length > 0 && isNumeric(newQty)) ? true : false;
  if (!result) {
    alert("Please add numbers only to input")
  }
  return result;
}

const ajaxQtyMin = (input, quantity) => {
  if (input == null) {
    return false;
  }
  let min = parseInt(input.dataset.min);
  if (min == NaN) {
    return false;
  }

  return parseInt(quantity) < min ;
}






